import blocksConfig from "../../config/blocks.json";
import { buildBlocksConfig } from "./blocksShared.js";

// Build-time overrides so a feature can be re-enabled for a single Netlify deploy context
// (e.g. deploy previews) without editing config/blocks.json.
const computed = buildBlocksConfig(blocksConfig, {
  lotteryEnabled: import.meta.env?.VITE_LOTTERY_ENABLED,
  telegramBotEnabled: import.meta.env?.VITE_TELEGRAM_BOT_ENABLED,
});

export const BLOCKS_LOTTERY_ENABLED = computed.BLOCKS_LOTTERY_ENABLED;
export const BLOCKS_TELEGRAM_BOT_ENABLED = computed.BLOCKS_TELEGRAM_BOT_ENABLED;
export const BLOCKS_PURCHASE_TOMAN = computed.BLOCKS_PURCHASE_TOMAN;
export const BLOCKS_PURCHASE_RIAL = computed.BLOCKS_PURCHASE_RIAL;
export const BLOCKS_TELEGRAM_CHANNEL = computed.BLOCKS_TELEGRAM_CHANNEL;
export const BLOCKS_TELEGRAM_MINI_APP_BOT = computed.BLOCKS_TELEGRAM_MINI_APP_BOT;
export const BLOCKS_TELEGRAM_ADMIN_ID = computed.BLOCKS_TELEGRAM_ADMIN_ID;
export const BLOCKS_MINI_APP_URL = computed.BLOCKS_MINI_APP_URL;

